import { authLogout } from "../../../store/actions/authActions";
import { clearAdminNotifications } from "../../../store/actions/notificationAdminActions";
import { clearMessage, setMessage } from "../../../store/actions/dialogActions";
import { setNotifications } from "../../../store/actions/notificationActions";
import API from "../../../store/api";

export const sendNotification = (to, body, subject, bearerAuth, clearNotificationFields) => {
  return async dispatch => {

    dispatch(setMessage({ type: 'LOAD' }))

    let req = API.post(`/api/portal/notification`)
      .set('Authorization', `Bearer ${bearerAuth}`)
      .field('data', JSON.stringify({
        to: to,
        body: body,
        subject: subject,
      }));
      req.ok(res => res.status === 200 || res.status === 401)
      .then((response) => {
        if (response.status === 200) {
          dispatch(clearMessage)
          dispatch(setNotifications({
            type: 'success',
            message: 'Successfully updated.'
          }))
          clearNotificationFields();
        } else if (response.status === 401) {
          dispatch(clearAdminNotifications);
          dispatch(authLogout);
        }
      }).catch((error) => {
        let message = 'An error has occurred';
        if (error.message) {
          message = error.message;
        }
        if (error.response && error.response.body) {
          if (error.response.body.messages) {
            message = error.response.body.messages.toString();
          }
        }
        dispatch(setMessage({
          title: 'Send Notification Failed',
          message: message,
          type: 'ERR',
        }))
      })
  }
}